/**
 *
 * CommunicationReminder
 *
 */

import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

import { useParams, useLocation } from 'react-router-dom';

// components
import TCFModal from 'components/TCFModal';
import {
  NotificationSimple,
} from 'components/Notifications';

import api, { setAuthorizationHeader } from 'utils/apis/axiosAPI';
// hooks
import { useAsync, useRefState } from 'utils/hooks';
// utils
import { getObjId, getUniqueArrayObj } from 'utils/helpers/helper.general';

function CommunicationReminder({
  open,
  isReminderLoading,
  // actions
  setOpen,
  setIsReminderLoading,
  onResult,
  // default props
  className
}) {
  const childClassNames = classNames('reminder-wrapper', className);

  const { id: initId } = useParams();

  const { isLoading, isSuccess, run, data, reset } = useAsync();

  const newKey = 'nouvel';

  const currentUser = JSON.parse(localStorage.getItem('schoolinked_user'));
  setAuthorizationHeader(currentUser?.token);

  const [initialID, setInitialID] = useState(false);

  // Because history not trigger update component
  useEffect(() => { 
    if (!!initId && initId != newKey) {
      setInitialID(initId);
    }
  }, [initId]);
  
  useEffect(() => { 
    setIsReminderLoading(isLoading);
  }, [isLoading]);

  useEffect(() => { 
    if (!!data && !isLoading && !!onResult) {
      // result : studentsFinal, result
      const { studentsFinal, result } = data;
      let resultData = [];
      result?.map(res => {
        const hasSuchStdIndex = resultData.findIndex(r => getObjId(r?.student) == getObjId(res?.response?.student));
        if (hasSuchStdIndex !== -1) {
          resultData[hasSuchStdIndex] = {
            ...resultData[hasSuchStdIndex],
            status:res?.result?.notification?.status
          }
        } else {
          resultData.push({
            student: res?.response?.student,
            recipients: res?.response?.recipients,
            status: res?.result?.notification?.status
          })
        }
      });
      onResult(resultData);
    }
  }, [data]);


  const onCancelModalHandler = useCallback(() => {
    !!setOpen && setOpen(false);
  }, [setOpen]);

  const onAddElementHandler = useCallback(() => {
    !isLoading && run(api.communications.remindCommunication(initialID));
    !!setOpen && setOpen(false);
  }, [initialID, setOpen, isLoading]);

  return (
    <>
      <NotificationSimple
        Loading={isLoading}
        Successful={isSuccess}
        message="Durant!"
        messageSuccess="Relancer réussi!"
        description=""
      />
      <TCFModal
        className={childClassNames}
        open={open}
        setOpen={setOpen}
        title="Relancer les étudiants ?"
        submitName="Relancer"
        loading={isLoading}
        confirmLoading={isSuccess}
        onCancel={onCancelModalHandler}
        onOk={onAddElementHandler}
      >
        <p>Les étudiants n’ayant pas encore répondus recevront une nouvelle notification de relance :</p>
      </TCFModal>
    </>
  );
}

CommunicationReminder.defaultProps = {
  open: false,
  loading: false,
  confirmLoading: false,
};

export default CommunicationReminder;
